export default __webpack_public_path__ + "src/assets/team.bdd5c03d6ab9c8cedbe043e375e9f922.svg";